import httpUtils from '@/utils/http-utils';
import i18n from '@/plugins/vue-i18n';

const baseRequesterOptions = {
  baseUrl: `${window.processEnv.VUE_APP_CRM_API_BASE_URL_V2}/saq-branches`,
  requesterType: 'CMS_WEB_SERVICE',
};
const branchesApiReqNotification = httpUtils.createRequester(baseRequesterOptions);
const branchesApiReqErrorHandling = httpUtils.createRequester(baseRequesterOptions, 'errorHandling');

const getRequester = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return branchesApiReqErrorHandling;
  }

  return branchesApiReqNotification; 
};

class CheckoutApi {
  fetchSaqBranches(withResultsIn, errorManagementType) {
    return getRequester(errorManagementType)
      .get('/', {
        params: {
          withResultsIn,
        },
        headers: {
          'accept-language': i18n.locale,
        },
      }).then(res => res && res.data);
  }
}

export default new CheckoutApi();
